import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

class SweetAlertService {
    static async fieldCantNull() {
        return MySwal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Form tidak boleh kosong!',
        });
    }

    static async fieldCantMinus() {
        return MySwal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Nilai tidak boleh minus!',
        });
    }

    static async warningAlert(){
        return MySwal.fire({
            title: 'Peringatan',
            text: 'Periksa kembali inputan anda !',
            icon: 'warning',
            timer: 5000,
            showConfirmButton: true
        })
    }

    static async chapchaAlert() {
        return MySwal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: 'Capcha tidak terverifikasi, silahkan refresh halaman',
        });
    }

    static async successAlert(){
        return MySwal.fire({
            title: 'Berhasil',
            text: 'Report berhasil dikirim',
            icon: 'success',
            timer: 5000,
            showConfirmButton: true
        })
    }

    static async errorAlert(){
        return MySwal.fire({
            title: 'Gagal',
            text: 'Report gagal dikirim',
            icon: 'error',
            timer: 5000,
            showConfirmButton: true
        })
    }

    static async maxFileSize() {
        return MySwal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ukuran file maksimal 2mb',
        });
    }

    static async mimesAlert() {
        return MySwal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'File harus berformat .jpeg, .jpg, .png, .webp',
        });
    }

    static async emailValidationAlert() {
        return MySwal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Format email salah',
        });
    }

}

export default SweetAlertService;
